function show_variant_image(e,product_handle){
  let parent_element = e.parentElement.parentElement.parentElement.parentElement.parentElement;
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      var product = JSON.parse(xhr.responseText);
      var product_featured_image, product_secondary_image;
   
      if (product.featured_image.includes('.png')) {
        product_featured_image = product.featured_image.split('.png')[0] + '.png';
      } else if (product.featured_image.includes('.jpg')) {
        product_featured_image = product.featured_image.split('.jpg')[0] + '.jpg';
      } else if (product.featured_image.includes('.jpeg')) {
        product_featured_image = product.featured_image.split('.jpeg')[0] + '.jpeg';
      }
  
      if (product.images[1].includes('.png')) {
        product_secondary_image = product.images[1].split('.png')[0] + '.png';
      } else if (product.images[1].includes('.jpg')) {
        product_secondary_image = product.images[1].split('.jpg')[0] + '.jpg';
      } else if (product.images[1].includes('.jpeg')) {
        product_secondary_image = product.images[1].split('.jpeg')[0] + '.jpeg';
      }
  
      var images = parent_element.querySelectorAll('.product-image__images img');
   
      function preloadImage(url) {
        var img = new Image();
        img.src = url;
      } 
  
      // Preload images
      preloadImage(product_featured_image);
      preloadImage(product_secondary_image);
  
      if (images[0]) {
        images[0].src = product_featured_image;
        images[0].srcset = product_featured_image;
        images[0].dataset.srcset = product_featured_image;
        images[0].dataset.src = product_featured_image;
  
        images[1].src = product_secondary_image;
        images[1].srcset = product_secondary_image;
        images[1].dataset.srcset = product_secondary_image;
        images[1].dataset.src = product_secondary_image;
      } else if (parent_element.parentElement.querySelectorAll('.product-image__images img')[0]) {
        parent_element = parent_element.parentElement;
        images = parent_element.querySelectorAll('.product-image__images img');
        images[0].src = product_featured_image;
        images[0].srcset = product_featured_image;
        images[0].dataset.srcset = product_featured_image;  
        images[0].dataset.src = product_featured_image;
  
        images[1].src = product_secondary_image;
        images[1].srcset = product_secondary_image;
        images[1].dataset.srcset = product_secondary_image;
        images[1].dataset.src = product_secondary_image;
      } 
    }
  };
  
  xhr.open('GET', window.Shopify.routes.root + 'products/' + product_handle + '.js', true);
  xhr.send();

   
}



// Mobile Quick Add
let all_quick_add_btns = document.querySelectorAll('.quick-add-mob');
let all_quick_btns_close = document.querySelectorAll('.quick-add-mob-close');


// Quick ATC Mob
function mobile_quick_atc(var_id, current_btn){
  let form_data = {
    'items': [{
      'id': var_id,
      'quantity': 1
    }]
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(form_data)
  })
  .then(response => {
    return response.json();
  })
  .then(data =>{
    if(current_btn.closest('.quick-add-prod-mob-main').querySelector('.quick-add-mob-main').classList.contains('active')){
      current_btn.closest('.quick-add-prod-mob-main').querySelector('.quick-add-mob-close').click();
    }
    if(data.status != 422){
      let all_cart_count_elm = document.querySelectorAll('.header-cart__count');
      let cart_count = Number(document.querySelector('.header-cart__count').innerHTML.trim());
      
      all_cart_count_elm.forEach((cart_count_elm)=>{
        cart_count_elm.innerHTML = cart_count + 1;
        if(cart_count == 0){
          cart_count_elm.style.cssText = "display: block !important";
        }
      })

      // Adding items to cart drawer
      fetch('/cart.js')
      .then(getResponse =>{
        return getResponse.json();      
      })
      .then(data=>{
        console.log("data --->", data);
        let cart_total_items = data.items.length;
        let cart_items = data.items;
        let cart_items_content = "";
        let cart_item_count = data.item_count;
        let all_ajax_cart = document.querySelectorAll('.ajax-cart--drawer');
        let all_cart_icon = document.querySelectorAll('.header-cart__icon');

        let currencySymbol = "$."
        // getting current currency symbol
        let amountStr = (document.querySelector('.ajax-cart__subtotal').querySelector('.money').innerHTML).trim();
        let match = amountStr.match(/^([^0-9]+)([\d,\.]+)$/);
        if(match){
          currencySymbol = match[1];
        }

        let cart_subtotal = `${currencySymbol}${(data.total_price/100).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        
        if(cart_item_count > 0){
          Shopify.theme.jsAjaxCart.updateView();
          // for(let i=0; i<cart_total_items; i++){
          //   let item_discounts = cart_items[i].discounts;
          //   cart_items_content += `
          //   <div class="ajax-cart__product media" data-cart-item="${cart_items[i].key}" data-line-item="${i + 1}" samitapbl-element="handle" p-handle="${cart_items[i].handle}">
          //     <figure class="ajax-cart__product-image media-left">
          //         <a href="${cart_items[i].url}" data-samitapbl-handle="${cart_items[i].handle}">
          //             <img src="${cart_items[i].image}" alt="${cart_items[i].title}" loading="lazy">
          //         </a>
          //     </figure>
          
          //     <div class="ajax-cart__product-content media-content">
          //         <div class="ajax-cart__product-content--left">
          //             <div class="ajax-cart__product-title is-font-heavy">
          //                 <a href="${cart_items[i].url}" data-samitapbl-handle="${cart_items[i].handle}">
          //                     ${cart_items[i].title}
          //                 </a>
          //             </div>
          //         </div>

          //         ${item_discounts.length > 0 ?
          //         `<div class="ajax-cart__product-content--right">
          //           <div class="ajax-cart__line-items-discount">
          //               <div class="ajax-cart__price-comparison">
          //                   <p class="sale">
          //                       <span class="money">
          //                           ${currencySymbol}${(cart_items[i].final_price/100).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          //                       </span>
          //                   </p>
          //                   <s class="original-price">
          //                       <span class="money">
          //                           ${currencySymbol}${(cart_items[i].price/100).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
          //                       </span>
          //                   </s>
          //               </div>
          //               <div class="line-item-discount__container">
          //                   <p>${item_discounts[0].title}</p>
          //               </div>
          //           </div>
          //           <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${cart_items[i].key}" href="/cart/change?line=${i + 1}&amp;quantity=0" title="Remove">
          //               Remove
          //           </a>
          //           <div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key="${i + 1}">
          //               <label class="label is-sr-only" for="quantity">Qty</label>
          //               <div class="quantity-wrapper quantity-style--box is-small">
          //                   <span class="quantity-minus quantity-element" data-update-quantity="minus">
          //                       <span class="icon " data-icon="minus">
          //                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><path d="M94,52H4a2,2,0,0,1,0-4H94a2,2,0,0,1,0,4Z"></path></g></svg>
          //                       </span>
          //                   </span>
          //                   <input class="quantity-input input" type="number" size="2" name="quantity" value="1" max="4631" data-max-inventory-management="" data-line-id="">
          //                   <span class="quantity-plus quantity-element" data-update-quantity="plus">
          //                       <span class="icon " data-icon="plus">
          //                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><path d="M95,48H52V5a2,2,0,0,0-4,0V48H5a2,2,0,0,0,0,4H48V95a2,2,0,0,0,4,0V52H95a2,2,0,0,0,0-4Z"></path></g></svg>
          //                       </span>
          //                   </span>
          //               </div>
          //           </div>
          //           <p class="ajax-cart__quantity-warning quantity-warning"></p>
          //       </div>`
          //           :
          //         `<div class="ajax-cart__product-content--right">
          //             <div class="ajax-cart__line-items-discount"></div>
          //             <div class="ajax-cart__price price">
          //                 <span class="money">${currencySymbol}${(cart_items[i].price/100).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
          //             </div>
          
          //             <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${cart_items[i].key}" href="/cart/change?line=${i + 1}&amp;quantity=0" title="Remove">
          //                 Remove
          //             </a>
          
          //             <div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key="${i + 1}">
          //                 <label class="label is-sr-only" for="quantity">Qty</label>
          //                 <div class="quantity-wrapper quantity-style--box is-small">
          //                     <span class="quantity-minus quantity-element" data-update-quantity="minus">
          //                         <span class="icon" data-icon="minus">
          //                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><path d="M94,52H4a2,2,0,0,1,0-4H94a2,2,0,0,1,0,4Z"></path></g></svg>
          //                         </span>
          //                     </span>
          //                     <input class="quantity-input input" type="number" size="2" name="quantity" value="1" max="145" data-max-inventory-management="" data-line-id="">
          //                     <span class="quantity-plus quantity-element" data-update-quantity="plus">
          //                         <span class="icon" data-icon="plus">
          //                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><path d="M95,48H52V5a2,2,0,0,0-4,0V48H5a2,2,0,0,0,0,4H48V95a2,2,0,0,0,4,0V52H95a2,2,0,0,0,0-4Z"></path></g></svg>
          //                         </span>
          //                     </span>
          //                 </div>
          //             </div>
          //             <p class="ajax-cart__quantity-warning quantity-warning"></p>
          //         </div>`}
          //     </div>
          // </div>`
          // }

          // Adding cart items in drawer
          // all_ajax_cart.forEach((ajax_cart)=>{
          //   ajax_cart.querySelector('.ajax-cart__list').innerHTML = cart_items_content;
          // })

          // // Setting Subtotal
          // all_ajax_cart.forEach((ajax_cart)=>{
          //   ajax_cart.querySelector('.ajax-cart__subtotal').querySelector('.money').innerHTML = cart_subtotal;
          // })

          // // Removing empty cart
          // all_ajax_cart.forEach((ajax_cart)=>{
          //   ajax_cart.querySelector('.ajax-cart__empty-cart-message').classList.add('is-hidden');
          // })
          
          // // Showing cart form
          // all_ajax_cart.forEach((ajax_cart)=>{
          //   ajax_cart.querySelector('.ajax-cart__form').classList.remove('is-hidden');
          // })

          // Clicking cart icon
          all_cart_icon.forEach((cart_icon)=>{
            cart_icon.click();
          }) 
        }
      })
    }
    else{
      let error_message = data.description;
      current_btn.closest('.product-card').querySelector('.quick-add-error').innerHTML = error_message;
      current_btn.closest('.product-card').querySelector('.quick-add-error').classList.add('active');
      setTimeout(()=>{
        current_btn.closest('.product-card').querySelector('.quick-add-error').classList.remove('active');
      },7000)
    }
  })
}

// Quick Add variant update
function soldout_variant_update(master_selector, current_variant, other_product_options){
  let all_disabled_variants = master_selector.querySelectorAll('option[disabled]');

  let arr_other_product_options = Array.from(other_product_options);

  let all_selected_product_options = arr_other_product_options.filter(arr_other_product_option => arr_other_product_option.hasAttribute('selected'));

  
  if(all_disabled_variants.length > 0){
    all_disabled_variants.forEach((disabled_variant)=>{
      let remove_soldout = true;
      let disabled_variant_title = disabled_variant.getAttribute('var-title');

      for(let i=0; i<all_selected_product_options.length; i++){
        if(disabled_variant_title.includes(all_selected_product_options[i].getAttribute('option-name'))){
          remove_soldout = false;
        }
      }

      if(remove_soldout){
        // Removing all soldout-variant class
        other_product_options.forEach((product_option)=>{
          product_option.removeAttribute('disabled');
        })
      }
      

      // Checking soldout-variant option and adding class
      if(disabled_variant_title.includes(current_variant)){
        let soldout_variant = disabled_variant_title.split(current_variant);
        let soldout_variant_options = soldout_variant.filter(function(value) {
          return value.trim() !== '';
        }).map(function(value) {
          return value.replace(/(^\/)|(\/$)/g, '');
        });

        soldout_variant_options.forEach((soldout_variant_option)=>{
          other_product_options.forEach((product_option)=>{
            if(product_option.getAttribute('option-name') == soldout_variant_option){
              product_option.setAttribute('disabled','');
            }
          })
        })
      }
      
    })
  }
}

if(all_quick_add_btns.length > 0){

  // Open
  all_quick_add_btns.forEach((quick_add_btn)=>{
    quick_add_btn.addEventListener('click', ()=> {

      // Closing Popus
      let check_closed_popups = document.querySelectorAll('.closed-popups-quick-add');
      if(check_closed_popups.length == 0){
        if(document.querySelector('.venn-deeplink-banner')){
          document.querySelector('.venn-deeplink-banner').querySelector('.venn-close-button').click()
        }
        if(document.querySelector('#preview-bar-iframe')){
          document.querySelector('#preview-bar-iframe').style.cssText = "display: none !important";
        }
  
        document.querySelector('body').classList.add('closed-popups-quick-add');
      }

      // Product With Options
      if(quick_add_btn.classList.contains('multi-variant-add')){
        
        let all_variant_options = quick_add_btn.closest('.quick-add-prod-mob-main').querySelector('.variant-options-main').querySelectorAll('.variant-option');
        let current_master_selector = quick_add_btn.closest('.quick-add-prod-mob-main').querySelector('.mob-master-selector-main');
        let current_master_selector_options = Number(current_master_selector.getAttribute('total_options'));
        

        // close opened variant options selector
        all_quick_add_btns.forEach((quick_add_btn_temp)=>{
          if(quick_add_btn_temp.closest('.product-card').querySelector('.quick-add-mob-main')){
            quick_add_btn_temp.closest('.product-card').querySelector('.quick-add-mob-main').classList.remove('active');
          }
        })

        // open current variant options selector
        quick_add_btn.closest('.product-card').querySelector('.quick-add-mob-main').classList.add('active');

        // Selecting option from variant options selector
        all_variant_options.forEach((variant_option)=>{
          variant_option.addEventListener('click', ()=> {
            let current_variant_other_options = variant_option.closest('.variant-options').querySelectorAll('.variant-option');

            current_variant_other_options.forEach((current_variant_other_option)=>{
              current_variant_other_option.removeAttribute('selected');
            })
            
            variant_option.setAttribute('selected', '');
            
            soldout_variant_update(current_master_selector, variant_option.getAttribute('option-name'), all_variant_options);
            
            let all_selected_variant = quick_add_btn.closest('.quick-add-prod-mob-main').querySelector('.variant-options-main').querySelectorAll('.variant-option[selected]');
            
            if(all_selected_variant.length == current_master_selector_options){
              let current_variant = "";
              
              for(let i=0; i<all_selected_variant.length; i++){
                let current_variant_option = all_selected_variant[i].getAttribute('option-name');
                
                if(i == all_selected_variant.length - 1){
                  current_variant +=  current_variant_option;
                } 
                
                else{
                  current_variant +=  `${current_variant_option}/`;
                }
                
              }
              let var_id = current_master_selector.querySelector(`option[var-title="${current_variant}"]`).getAttribute('var-id');
              mobile_quick_atc(var_id, quick_add_btn);
            }
          })
        })
      }

      // Product Without Options
      else if(quick_add_btn.classList.contains('single-variant-add')){
        let var_id = quick_add_btn.closest('.product-card').querySelector('.mob-master-selector-main').querySelector('option').getAttribute('var-id');
        mobile_quick_atc(var_id, quick_add_btn);
      }
      
    })
  })

  // Close
  all_quick_btns_close.forEach((quick_btn_close)=>{
    quick_btn_close.addEventListener('click', ()=> {
      let all_selected_variants = quick_btn_close.closest('.quick-add-prod-mob-main').querySelector('.variant-options-main').querySelectorAll('.variant-option');
      all_selected_variants.forEach((selected_variants)=>{
        selected_variants.removeAttribute('selected');
        selected_variants.removeAttribute('disabled');
      })
      quick_btn_close.closest('.quick-add-mob-main').classList.remove('active');
    })
  })
}


















